import ExtrasMobile from "./ExtrasMobile";

export default ExtrasMobile;
export { ExtrasMobile };
